module.exports = __webpack_public_path__ + "img/pause-square.08979533.svg";